"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfPngPictureExporter = void 0;
var tslib_1 = require("tslib");
var rtf_export_sr_1 = require("../../../translation-table/rtf-export-sr");
var rtf_picture_exporter_1 = require("./rtf-picture-exporter");
var RtfPngPictureExporter = (function (_super) {
    tslib_1.__extends(RtfPngPictureExporter, _super);
    function RtfPngPictureExporter(rtfBuilder, run, base64Uri) {
        return _super.call(this, rtfBuilder, run, base64Uri) || this;
    }
    RtfPngPictureExporter.prototype.getRtfPictureType = function () {
        return rtf_export_sr_1.RtfExportSR.PNGPictureKeyword;
    };
    return RtfPngPictureExporter;
}(rtf_picture_exporter_1.RtfPictureExporter));
exports.RtfPngPictureExporter = RtfPngPictureExporter;
